module.exports = __webpack_public_path__ + "img/list-pattern2.d3fb9ae.svg";